import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";


@Injectable()
export class PredialService {
  constructor(public http: HttpClient) { }

  getImagenes() {
    const url = environment.URL_PREDIAL + "/publicidad";
    return this.http.get<any>(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getMostrar() {
    const url = environment.URL_PREDIAL + "/mostrar";
    return this.http.get<any>(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getConsulta(clave_catastral:any) {
    console.log(clave_catastral)
    const url = environment.URL_PREDIAL + "/consulta/" + clave_catastral;
    return this.http.get<any>(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

 /* envioDatos(data:any) {
    const url = environment.URL_BECAS2018 + "/consulta_estado";
    return this.http.post(url, data).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }*/

  proces3ds(data:any) {
    const url = environment.URL_PREDIAL + environment.METODO_PREDIAL;
    return this.http.post(url, data, {
      responseType: 'text'
    }).pipe(
      map((resp: any) => {
        console.log(resp)
        return resp;
      })
    );
  }
  proces3ds2(data: any) {
    
    const url = environment.URL_PREDIAL + environment.METODO_PREDIAL2;
    console.log(url)
    
    
    return this.http.post(url, data, {
      responseType: 'text'
    }).pipe(
      map((resp: any) => {
        console.log(resp)
        return resp;
      })
    );
  }

  getInfoTarjeta(tarjeta){
    const url = 'https://lookup.binlist.net/' + tarjeta;
    return this.http.get(url).pipe(map((resp: any) => {
      
      return resp;
    }));
  }


  /*
  getPdf(ClaveCatastral: any) {
    const url = environment.URL_PREDIAL + "/recibopdf/" + ClaveCatastral;
    return this.http
      .get(url, { responseType: "blob" }).pipe(
        map((resp: any) => {
          const downloadUrl = window.URL.createObjectURL(resp);
          window.open(downloadUrl);
        })
      );
  }*/

}
